import { Button, Col, Divider, Row } from "antd";
import styles from "./Applications.module.scss";
import WebStarNotebookOnly from "./../../../assets/images/1WebStarNotebookOnly.jpg";
import WebTabs from "./../../../assets/images/WebTabs.jpg";
import WebStylus from "./../../../assets/images/MobilePicApp.png";
import WebPurpuleMobile from "./../../../assets/images/WebPurpuleMobile.jpg";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function ApplicationsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      {" "}
      <div className={styles.pageWrapper}>
        <div className={styles.NotebookWrapper}>
          <div>
            <div className={styles.Title600_32_44}>
              {t("Application.headTitle")}
            </div>
          </div>
        </div>
        <div className={styles.BlueWrapper}>
          <div className={styles.Title700_36_54}>
            {t("Application.importanceHeader")}
          </div>
          <div>
            <div>
              <div>
                {" "}
                <p className={styles.BlueText}>
                  {t("Application.importanceDescription")}
                </p>{" "}
              </div>{" "}
              <div>
                <div className={styles.LaptopBlock}>
                  <div className={styles.PurpleTitle}>
                    {" "}
                    {t("Application.presenceHeader")}{" "}
                  </div>
                  <p className={styles.BlueText}>
                    {t("Application.presenceDescription")}
                  </p>{" "}
                  <div className={styles.PurpleTitle}>
                    {" "}
                    {t("Application.informationHeader")}
                  </div>
                  <p className={styles.BlueText}>
                    {t("Application.informationDescription")}
                  </p>{" "}
                </div>{" "}
                <div>
                  {" "}
                  <img
                    className={styles.WebStarNotebookOnly}
                    src={WebStarNotebookOnly}
                    alt={WebStarNotebookOnly}
                  />
                </div>
              </div>
              <div className={styles.LaptopBlock}>
                {" "}
                <div className={styles.PurpleTitle}>
                  {" "}
                  {t("Application.marketingHeader")}
                </div>
                <p className={styles.BlueText}>
                  {t("Application.marketingDescription")}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.typesWebsitesBlock}>
          <h5 className={styles.Title700_36_54Purple}>
            {t("Application.webSiteTypesHeader")}
          </h5>
          <div className={styles.TypesWrap}>
            {" "}
            <img src={WebTabs} alt={WebTabs} className={styles.WebTabs} />
            <div className={styles.websiteBlock}>
              <div>
                <ul className={styles.TypesList}>
                  <li> E-commerce Websites</li>
                  <li> Blogs </li>
                  <li>{t("Application.informationalWebsites")}</li>
                  <li> Portfolio Websites</li>
                  <li>{t("Application.socialMediaWebsites")}</li>
                </ul>
              </div>{" "}
              <div>
                <ul className={styles.TypesList}>
                  <li>{t("Application.forumWebsites")}</li>
                  <li>{t("Application.businessWebsites")}</li>
                  <li>{t("Application.educationWebsites")}</li>
                  <li>{t("Application.mediaWebsites")}</li>
                  <li>{t("Application.governmentWebsites")}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.MobileWrapper}>
          <div className={styles.MobileContent}>
            <div className={styles.Title700_36_54}>
              {t("Application.mobileAppsTypeHeader")}
            </div>
            <div className={styles.Text700_20_30}> Native Apps: </div>
            <p className={styles.Text400_20_30}>
              {t("Application.nativeDescription")}
            </p>{" "}
            <div className={styles.Text700_20_30}> Web Apps: </div>
            <p className={styles.Text400_20_30}>
              {t("Application.webDescription")}
            </p>{" "}
            <div className={styles.Text700_20_30}> Hybrid Apps: </div>
            <p className={styles.Text400_20_30}>
              {t("Application.hybridDescription")}
            </p>
          </div>
        </div>
        <div className={styles.developmentStages}>
          <div className={styles.Title700_36_54Purple}>
            {t("Application.developmentStages")}
          </div>
          <div className={styles.developmentButtonsWrapper}>
            <Button
              onClick={() =>
                navigate({
                  pathname: "/services/design",
                })
              }
              className={`${styles.stagesBtn} ${styles.stagesBtn1}`}
            >
              UI/UX Design
            </Button>

            <Button
              onClick={() =>
                navigate({
                  pathname: "/services/frontend",
                })
              }
              className={`${styles.stagesBtn} ${styles.stagesBtn2}`}
            >
              Frontend development
            </Button>

            <Button
              onClick={() =>
                navigate({
                  pathname: "/services/backend",
                })
              }
              className={`${styles.stagesBtn} ${styles.stagesBtn3}`}
            >
              Backend development
            </Button>
          </div>
        </div>
        <div className={styles.keyConsiderationBlock}>
          <div className={styles.ConsiderationTitle}>
            {t("Application.keyConsideration")}
          </div>
          <div className={styles.lastWrapper}>
            <div className={styles.considerationsBlock}>
              <p className={styles.Text400_20_30}>
                <span className={styles.Text700_20_30}>
                  {t("Application.platformHeader")}
                </span>{" "}
                {t("Application.platformDescription")}
              </p>
              <p className={styles.Text400_20_30}>
                <span className={styles.Text700_20_30}>
                  {t("Application.userExpHeader")}
                </span>{" "}
                {t("Application.userExpDescription")}
              </p>
            </div>{" "}
            <img
              className={styles.mobileAppPic}
              src={WebStylus}
              alt={WebStylus}
            />
            <div className={styles.considerationsBlock}>
              <p className={styles.Text400_20_30}>
                <span className={styles.Text700_20_30}>
                  {t("Application.performerHeader")}
                </span>{" "}
                {t("Application.performerDescription")}
              </p>
              <p className={styles.Text400_20_30}>
                <span className={styles.Text700_20_30}>
                  {t("Application.testingHeader")}
                </span>{" "}
                {t("Application.testingDescription")}
              </p>
            </div>
          </div>
        </div>
        <div className={styles.divider}> </div>
        <img
          className={styles.purpleMobilePic}
          //   className={styles.mockupGadgets}
          src={WebPurpuleMobile}
          alt={WebPurpuleMobile}
        />
        <div className={styles.rowWrap}>
          {" "}
          <div className={styles.mockupGadgetsText}>
            {t("Application.footer")}
          </div>
          <img
            className={styles.PurplePic}
            //   className={styles.mockupGadgets}
            src={WebPurpuleMobile}
            alt={WebPurpuleMobile}
          />
        </div>
      </div>
    </>
  );
}
